import logo from '../../Assets/footer-logo.png'

const Footer = () => {
  return (
    <footer>
      <div className="container-fluid">
        <div className="footer-top__flex">
          <div className="footer__compamiinfo">
            <div className="footer__compamiinfo--logo">
              <img src={logo} alt="" />
            </div>
            <div className="footer__compamiinfo--content">
              <p>
                Lenox, The essence of Lenox paints lies in the interplay of vibrant and bright colours that breathe life into every surface of your living space. Lenox, as the name suggests, is truly the celebration of revolution and the beauty in the newness. Just as revolution signifies the fresh beginning, every application of Lenox paints brings an absolute transformation to your space into a real masterpiece, acknowledging the spirit of vibrance.
              </p>
            </div>
          </div>
          <div className="footer__quick-links">
              <h3>OUR PRODUCTS</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/about">About us</a></li>
                <li><a href="/interior-emulsions">Interior Emulsions</a></li>
                <li><a href="/exterior-emulsions">Exterior Emulsions</a></li>
                <li><a href="/primers">Primers</a></li>
                <li><a href="/enamels">Enamels</a></li>
                <li><a href="/special-products">Special Products</a></li>
                <li><a href="/blogs">Blogs</a></li>
                <li><a href="/">Download Brochure</a></li>
                <li><a href="/contact">Contact Us</a></li>
              </ul>
            </div>
          <div className="footer__address">
            <h3>ADDRESS</h3>
            <p>
              #785, Ground Floor, 16th Main Road<br />
              23rd 'A' Cross, Near HSR Club <br />
              HSR Layout, 3rd Sector<br />
              Bangalore - 560102 <br />
            </p>

             <h3>Policy</h3>
            <ul>
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/terms">Terms of Conditions</a></li>
              </ul>
          </div>
          <div className="footer__email">
            <h3>EMAIL</h3>
            <ul>
              <li><a href="mailto:info@lenoxpaints.com">info@lenoxpaints.com</a></li>
            </ul>
          </div>
          <div className="footer__contact-number">
            <h3>CONTACT NUMBER</h3>
            <ul>
              <li><a href="tel:+919108433368">+91 91084 33368</a></li>
              <li><a href="tel:+919108433369">+91 91084 33369</a></li>
            </ul>
             <h3>TOLL FREE NUMBER</h3>
            <ul>
              <li><a href="tel:+9118002033309">1800 203 3309</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; 2026. Lenox Paints Pvt Ltd. All Rights Reserved. Designed and Developed by <a href='https://www.digiworq.com' target='_blank' style={{color: "white"}}>DIGIWORQ</a>
          </p>
        </div>
      </div>
    </footer>
    // Designed & Developed By <a href="https://www.digiworq.com/">Digiworq</a
  );
};

export default Footer;
